export enum RoutesEnum {
  LOGIN = '/login',
  RESET_PASSWORD = '/resetPassword',
  RESET_PASSWORD_WITH_TOKEN = '/resetPassword/:resetPasswordToken',
  SSO_CALLBACK = '/auth/sso/callback',
  SSO_ERROR = '/ssoerror',
  HOME = '/',
  SETTINGS = '/settings',
  ACTIVITIES = '/activities',
}

export const ROUTES = {
  home: () => '/',
  login: () => '/login',
  resetPassword: (resetPasswordToken?: string) => `/resetPassword/${resetPasswordToken}`,
  ssoCallback: () => '/auth/sso/callback',
  ssoError: () => '/ssoerror',
  settings: () => '/settings',
  activities: () => '/activities',
}
